import { BookOpen, FlaskConical, Atom, Palette, Monitor, FileText, Grid3X3 } from 'lucide-react';

export interface SubjectStyleInfo {
  textAccent: string;
  dueText: string;
  iconBg: string;
  icon: React.ReactNode;
}

/**
 * The colour and icon a subject's work is drawn with.
 *
 * Only the look is keyed by a guess at the subject; the name printed beside it
 * is always the one the school gave it. Printing a fixed label from the same
 * guess turned Marathi into "MATHS" and anything with "it" in it into
 * "COMPUTER".
 */
export function getSubjectStyle(subject: string): SubjectStyleInfo {
  const norm = subject.toLowerCase();
  if (norm.includes('math')) {
    return {
      textAccent: 'text-emerald-600 dark:text-emerald-400 font-bold',
      dueText: 'text-emerald-600 dark:text-emerald-400',
      iconBg: 'bg-emerald-50 text-emerald-600 border border-emerald-200 dark:bg-emerald-950/40 dark:border-emerald-800/60 dark:text-emerald-400',
      icon: <Grid3X3 className="h-6 w-6" />,
    };
  }
  if (norm.includes('telugu') || norm.includes('hindi') || norm.includes('lang') || norm.includes('tamil') || norm.includes('sanskrit')) {
    return {
      textAccent: 'text-indigo-600 dark:text-indigo-400 font-bold',
      dueText: 'text-indigo-600 dark:text-indigo-400',
      iconBg: 'bg-indigo-50 text-indigo-600 border border-indigo-200 dark:bg-indigo-950/40 dark:border-indigo-800/60 dark:text-indigo-400',
      icon: <BookOpen className="h-6 w-6" />,
    };
  }
  if (norm.includes('chem')) {
    return {
      textAccent: 'text-amber-600 dark:text-amber-400 font-bold',
      dueText: 'text-amber-600 dark:text-amber-400',
      iconBg: 'bg-amber-50 text-amber-600 border border-amber-200 dark:bg-amber-950/40 dark:border-amber-800/60 dark:text-amber-400',
      icon: <FlaskConical className="h-6 w-6" />,
    };
  }
  if (norm.includes('evs') || norm.includes('phy') || norm.includes('sci') || norm.includes('bio')) {
    return {
      textAccent: 'text-cyan-600 dark:text-cyan-400 font-bold',
      dueText: 'text-cyan-600 dark:text-cyan-400',
      iconBg: 'bg-cyan-50 text-cyan-600 border border-cyan-200 dark:bg-cyan-950/40 dark:border-cyan-800/60 dark:text-cyan-400',
      icon: <Atom className="h-6 w-6" />,
    };
  }
  if (norm.includes('eng')) {
    return {
      textAccent: 'text-blue-600 dark:text-blue-400 font-bold',
      dueText: 'text-blue-600 dark:text-blue-400',
      iconBg: 'bg-blue-50 text-blue-600 border border-blue-200 dark:bg-blue-950/40 dark:border-blue-800/60 dark:text-blue-400',
      icon: <BookOpen className="h-6 w-6" />,
    };
  }
  if (norm.includes('art') || norm.includes('craft') || norm.includes('draw')) {
    return {
      textAccent: 'text-amber-600 dark:text-amber-400 font-bold',
      dueText: 'text-amber-600 dark:text-amber-400',
      iconBg: 'bg-amber-50 text-amber-600 border border-amber-200 dark:bg-amber-950/40 dark:border-amber-800/60 dark:text-amber-400',
      icon: <Palette className="h-6 w-6" />,
    };
  }
  if (norm.includes('comp') || norm.includes('it') || norm.includes('tech') || norm.includes('ai') || norm.includes('cs')) {
    return {
      textAccent: 'text-sky-600 dark:text-sky-400 font-bold',
      dueText: 'text-sky-600 dark:text-sky-400',
      iconBg: 'bg-sky-50 text-sky-600 border border-sky-200 dark:bg-sky-950/40 dark:border-sky-800/60 dark:text-sky-400',
      icon: <Monitor className="h-6 w-6" />,
    };
  }
  return {
    textAccent: 'text-slate-600 dark:text-slate-300 font-bold',
    dueText: 'text-slate-600 dark:text-slate-300',
    iconBg: 'bg-slate-50 text-slate-600 border border-slate-200 dark:bg-slate-800/60 dark:border-slate-700 dark:text-slate-300',
    icon: <FileText className="h-6 w-6" />,
  };
}
